export default class Chartbeat {
  constructor(player, youtubeVideoPlayer) {
    if (!player.allowPersonalizedCookies()) {
      return;
    }

    const accountId = player && player.asset && player.asset.chartbeat_account_id;
    if (!accountId) {
      throw new Error('accountId is required');
    }
    if (!youtubeVideoPlayer) {
      throw new Error('youtubeVideoPlayer is required');
    }

    // http://support.chartbeat.com/docs/video.html#youtube
    // eslint-disable-next-line camelcase
    var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});
    _sf_async_config.uid = accountId;
    _sf_async_config.domain = (new URL(player.host.host.url)).host;

    function loadChartbeat() {
      var e = document.createElement('script');
      var n = document.getElementsByTagName('script')[0];
      e.type = 'text/javascript';
      e.async = true;
      e.src = '//static.chartbeat.com/js/chartbeat_video.js';
      n.parentNode.insertBefore(e, n);
    }

    var _cbv = window._cbv || (window._cbv = []);
    // specify the video object to chartbeat
    _cbv.push(youtubeVideoPlayer);
    loadChartbeat();
  }
}
